import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown, faSearch } from '@fortawesome/pro-regular-svg-icons';
import cn from 'classnames';
import './NewCircleModalIntro.scss';

import { getCuratorGroups } from '../../../../Helpers/user_helpers';

import SmartImage from '../../../General/SmartImage';

const NewCircleModalIntro = props => {
  const { user, selectedCurators, activeGroup } = props;
  const [activeFaqIdx, setActiveFaqIdx] = React.useState(null);
  const toggleFaq = idx => setActiveFaqIdx(idx === activeFaqIdx ? null : idx);
  const hasCuratorGroups = getCuratorGroups(user).length > 0;
  const faq = [
    {
      question: 'What is a Circle?',
      answer: `A Circle is your personal team of tastemakers—people whose recommendations you trust. Add your favorite curators, and we'll automatically turn their picks into a beautiful, shoppable feed.`
    },
    {
      question: 'How many curators should I add?',
      answer:
        'We recommend adding at least 3 curators to unlock a more diverse range of recommendations. The more voices you trust, the better your discovery experience becomes.'
    },
    ...(hasCuratorGroups
      ? [
          {
            question: "What if I can't find a specific curator?",
            answer: `You can currently add curators who have a ShopMy account and are approved as Trendsetters or Icons. Can't find someone? Ask them to share their ShopMy link—then just tap the heart icon to add them to your Circle.`
          }
        ]
      : [
          {
            question: 'How is this different from a "follow"',
            answer:
              'Following is passive — Circles are personal. You handpick a small group of curators whose taste you trust, and we turn that into a signal-rich shopping experience, just for you.'
          }
        ])
  ].map((faq, idx) => ({ ...faq, isActive: idx === activeFaqIdx }));

  // const allowCompletingAsPrimaryAction = initial_curators.length === 1 && !!selectedCurators.length;

  return (
    <div className='new-circle-modal-intro-container'>
      <div className='new-circle-modal-intro-content'>
        <SmartImage src='http://static.shopmy.us/Create+Circle+Example.png' growIn alt='Circle Example' />
      </div>
      <div className='title-container'>
        <div className='title'>{activeGroup ? 'Add to your circle' : hasCuratorGroups ? 'Create a new circle' : 'Create your first circle'}</div>
        <div className='description'>
          {activeGroup?.title
            ? `Search or discover new curators to add to your circle.`
            : `Curate your own group of trusted voices to help you discover products you'll love.`}
        </div>
        <div className='action-btns'>
          <div className={cn('action-btn with-icon', { primary: activeGroup, secondary: !activeGroup })} onClick={props.pressToSearch}>
            <FontAwesomeIcon icon={faSearch} />
            Search Curators
          </div>
          <div className={cn('action-btn', { primary: !activeGroup, secondary: activeGroup })} onClick={props.goToNextPanel}>
            {activeGroup ? 'Discover Curators' : selectedCurators.length ? 'Discover Curators' : hasCuratorGroups ? 'Get Started' : 'Get Started'}
          </div>
        </div>
      </div>
      <div className='faq-container'>
        {faq.map((faq, idx) => {
          const { question, answer, isActive } = faq;
          const toggle = () => toggleFaq(idx);
          return (
            <div className='faq-item' key={faq.idx}>
              <div className='faq-question-container' onClick={toggle}>
                <div className='faq-question'>{question}</div>
                <div className='faq-question-icon'>
                  {isActive ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}
                </div>
              </div>
              {isActive && <div className='faq-answer'>{answer}</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
};

NewCircleModalIntro.propTypes = {
  user: PropTypes.object.isRequired,
  goToNextPanel: PropTypes.func.isRequired,
  pressToSearch: PropTypes.func.isRequired,
  goToFinalPanel: PropTypes.func.isRequired,
  selectedCurators: PropTypes.array.isRequired,
  initial_curators: PropTypes.array.isRequired,
  activeGroup: PropTypes.object
};

export default NewCircleModalIntro;
